import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
// import {
//     TextField, Button, Container, Paper, Typography, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions
// } from "@mui/material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
// import Person from "@mui/icons-material/Person";
import { useSelector } from "react-redux";
import axios from "axios";
import { Person, AdminPanelSettings, Cancel } from "@mui/icons-material";
import { Image as ImageIcon } from "@mui/icons-material";
import toast from "react-hot-toast";
import { api_url } from "../utils/Config";

function Support() {
  const { walletAddress } = useSelector((state) => state.wallet);

  const [formData, setFormData] = useState({
    userId: walletAddress,
    subject: "",
    title: "",
  });
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [fileInput, setFileInput] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null); // create the ref

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.subject || !formData.title) {
      return toast.error("All fields are required");
    }
    setLoading(true);
    try {
      const res = await axios.post(`${api_url}/auth/raise-query`, formData);
      if (res.status === 201) {
        toast.success(res.data.message);
        fetchChats();
        setOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to create ticket");
    }
    setLoading(false);
  };

  const fetchChats = useCallback(async () => {
    try {
      const res = await axios.post(`${api_url}/auth/get-chats`, {
        address: walletAddress,
      });
      if (res.status === 200) {
        setInfo(
          res.data.chats?.sort((a, b) => b.timestamp - a.timestamp) || []
        );
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
    }
  }, [walletAddress]);

  useEffect(() => {
    fetchChats();
  }, [fetchChats]);

  useEffect(() => {
    if (info.length > 0) {
      setMessages(info[0]?.chats || []);
    }
  }, [info]);

  const sendChats = async (ticketItem) => {
    if (!input.trim()) return toast.error("Message cannot be empty");
    try {
      const res = await axios.post(`${api_url}/auth/send-message`, {
        userId: walletAddress,
        ticketId: ticketItem?.ticketId,
        chats: input,
        type: "user",
      });
      if (res.data.status !== 400) {
        setMessages([...messages, { message: input, type: "user" }]);
        setInput("");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send message!");
    } finally {
      fetchChats();
    }
  };

  const sendImageChats = async (item) => {
    const formData = new FormData();
    const data = {
      userId: walletAddress,
      ticketId: item?.ticketId,
      chats: fileInput,
      type: "user",
    };
    formData.append("chats", data?.chats);
    formData.append("ticketId", data?.ticketId);
    formData.append("userId", data?.userId);
    formData.append("type", data?.type);
    if (selectedImage) {
      formData.append("file", selectedImage);
    }

    try {
      await axios.post(api_url + "/auth/send-file-chat", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setInput("");
      setSelectedImage(null);
      fetchChats(); // Refresh chat
    } catch (err) {
      console.error("Error sending chat", err);
    }
  };

  return (
    <>
      <div className="p-3 d-flex align-items-end justify-content-end">
        <Button variant="outlined" onClick={() => setOpen(true)}>
          Create Ticket
        </Button>
      </div>
      <Container>
        {info.map((item, i) => (
          <Accordion key={i} defaultExpanded={!item?.ticketClosed}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <Typography variant="h6" color="primary">
                  Ticket-ID: {item?.ticketId}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color={item?.ticketClosed ? "error" : "success"}
                  className="ms-3"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <span>
                    Status: {item?.ticketClosed ? "Closed" : "Active"}
                  </span>
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Paper className="p-3">
                <div
                  className="border p-3 mt-2"
                  style={{ height: "300px", overflowY: "scroll" }}
                >
                  {item?.chats.length > 0 ? (
                    item.chats.map((msg, index) => (
                      <div
                        key={index}
                        className={`mb-3 d-flex flex-column ${
                          msg.type === "user"
                            ? "align-items-end"
                            : "align-items-start"
                        }`}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{
                            width: "50%",
                            alignItems: "end",
                            justifyContent:
                              msg.type === "user" ? "end" : "start",
                          }}
                        >
                          {msg.type === "admin" && (
                            <AdminPanelSettings className="me-2" />
                          )}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              background: "rgba(0,0,0,0.1)",
                              padding: "5px",
                              borderRadius: 7,
                              maxWidth: "70%",
                            }}
                          >
                            {msg.filepath && (
                              <img
                                src={`${api_url}/uploads/${msg.filepath}`}
                                alt="chat"
                                style={{
                                  maxWidth: "100%",
                                  //   maxHeight: "200px",
                                  borderRadius: "6px",
                                  marginBottom: msg.message ? "5px" : "0",
                                }}
                              />
                            )}
                            {msg.message && (
                              <span
                                className={`badge text-wrap ${
                                  msg.filepath
                                    ? " "
                                    : msg.type === "user"
                                    ? "bg-primary"
                                    : "bg-secondary"
                                }`}
                                style={
                                  msg.filepath && {
                                    color: "rgba(0,0,0,0.7)",
                                  }
                                }
                              >
                                {msg.message}
                              </span>
                            )}
                          </div>
                          {msg.type === "user" && <Person className="ms-2" />}
                        </div>
                      </div>
                    ))
                  ) : (
                    <Typography className="text-center text-muted">
                      No messages yet
                    </Typography>
                  )}
                </div>

                {!item?.ticketClosed && (
                  <div className="mt-3">
                    {/* Image preview if selected */}
                    {selectedImage ? (
                      <div className="mb-2">
                        <Card>
                          <CardMedia
                            component="img"
                            image={URL.createObjectURL(selectedImage)}
                            alt="Selected"
                            style={{
                              objectFit: "contain",
                              maxHeight: "200px",
                              width: "100%",
                            }}
                          />
                          <CardContent>
                            <TextField
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={fileInput}
                              onChange={(e) => setFileInput(e.target.value)}
                              placeholder="Type a message..."
                            />
                            <Button
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedImage(null);
                                setFileInput("");
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = ""; // reset file input
                                }
                              }}
                              className="mt-1"
                            >
                              Remove Image
                            </Button>
                          </CardContent>
                        </Card>
                      </div>
                    ) : null}

                    {/* Message + Image upload actions */}
                    <div className="d-flex">
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        ref={fileInputRef}
                        id={`upload-${item.id}`}
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            setSelectedImage(e.target.files[0]);
                          }
                        }}
                      />
                      <label htmlFor={`upload-${item.id}`}>
                        <Button
                          variant="outlined"
                          component="span"
                          className="me-2"
                          startIcon={<ImageIcon />}
                        >
                          Image
                        </Button>
                      </label>

                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Type your message..."
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        className="ms-2"
                        onClick={() =>
                          selectedImage ? sendImageChats(item) : sendChats(item)
                        }
                        disabled={input.trim().length === 0 && !selectedImage}
                      >
                        Send
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        className="ms-2"
                        onClick={fetchChats}
                      >
                        Refresh
                      </Button>
                    </div>
                  </div>
                )}
              </Paper>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
      {/* MUI Dialog for Creating Ticket */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <div
          className="d-flex justify-content-end pt-3 pe-3"
          onClick={() => setOpen(false)}
        >
          <Cancel className="cursor-pointer" />
        </div>
        <DialogTitle sx={{ color: "black" }}>Create Support Ticket</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="User ID"
            value={formData.userId}
            disabled
            margin="dense"
          />
          <TextField
            fullWidth
            label="Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            margin="dense"
          />
          <TextField
            fullWidth
            label="Title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            color="primary"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Ticket"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Support;
